/*
 * サブシステム名：燃費管理
 * 機能名：車両別燃費管理
 */
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import date from '@/ddv2.library/date'
// import d2fmt from '@/ddv2.library/utils/formatter'
import header from '@/ddv2.library/header'
// import indexeddb from '@/ddv2.library/indexeddb'

import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdCustomButton from '@/components/DdCustomButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdListHeader from '@/components/DdListHeader'
import DdSpreadSheet from '@/components/DdSpreadSheet'
import DdTextBox from '@/components/DdTextBox'
import DdTransparentButton from '@/components/DdTransparentButton'

const DdYearMonthBoxWithSelector = () => import('@/components/DdYearMonthBoxWithSelector')

export default {
  name: 'MstJininListEdit',
  mixins: [flowMixin],
  components: {
    DdCheckbox,
    DdCodeTextBox,
    DdCustomButton,
    DdIconButtonWithTooltip,
    DdListHeader,
    DdSpreadSheet,
    DdTextBox,
    DdTransparentButton,
    DdYearMonthBoxWithSelector
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      sharyoNo: '',
      jidoshaHyojiNm: '',
      eigyoshoCd: ''
    },
    // 保存用
    targetKyuyuJissekiList: [],

    searchedKeijoNengetsu: null,
    searchedEigyoshoCd: null,
    searchedJidoshaHyojiNm: null,
    modeKengen: 0,
    pageCount: 0,
    // ヘッダー定義
    headersEigyoshoList: header.mstEigyoshoHeaders,

    // スプレッドシートオプション
    option: {
      // テーブル最大高さ
      tableHeight: '60vh',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列固定
      freezeColumns: 1,
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: false,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: true,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: true,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 25,
      paginationOptions: [10, 20, 50, 100, 150, 200],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む',
        noRecordsFound: '対象データがありません'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoList: 'DDMasters/mstEigyosho',
      sharyoList: 'DDMasters/vwCMstSharyo',
      usersEigyoshoCd: 'users/eigyoshoCd',
      currentKaishaCode: 'users/currentKaishaCode',
      kubunList: 'DDMasters/msysKubun',
      helpUseFlg: 'users/helpUseFlg'
    }),
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },

    // 燃料区分フィルター
    filteredNenryoKubunList () {
      const self = this
      return self.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'SFF053' && elem.kaishaCd === self.currentKaishaCode
      })
    },

    isMultiSaveButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true
      })
      if (saveTargetRow.length < 1) {
        return true
      }
      return false
    },

    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmstsharyo'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.setHeader()
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          console.log('★★★', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstJininList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstJininList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstJininList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstJininList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1
      this.searchedKeijoNengetsu = this.conditions.keijoNengetsu
      this.searchedEigyoshoCd = this.conditions.eigyoshoCd
      this.searchedJidoshaHyojiNm = this.conditions.jidoshaHyojiNm

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCD2fued0060/search', self.conditions)
              .then((data) => {
                self.setHeader(data.payload.nenryoKubunList)
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          // マスターとなる燃料の順序を定義
          const masterFuelOrder = ['01', '02', '03', '04', '05']

          // 表示対象の燃料区分リストを取得し、マスター順序に基づいてソートする
          const enabledKubunList = (data.payload.nenryoKubunList || [])
            .slice() // 元の配列を保護するためにコピー
            .sort((a, b) => masterFuelOrder.indexOf(a) - masterFuelOrder.indexOf(b))

          const kubunToFormulaPropMap = new Map([
            ['01', 'kingakuRegularFormula'],
            ['02', 'kingakuHighOctaneFormula'],
            ['03', 'kingakuDieselFormula'],
            ['04', 'kingakuLpGasFormula'],
            ['05', 'kingakuNaturalGasFormula']
          ])
          self.rows = data.payload.resultList.map((elem, index) => {
            elem.editFlg = false
            elem.errFlg = false
            const y = index + 1

            // --- STEP 1: すべての列名を動的に計算 ---
            let currentColCharCode = 'D'.charCodeAt(0)

            // 給油量セクション
            const kyuryoCol = {}
            enabledKubunList.forEach(kubun => { kyuryoCol[kubun] = String.fromCharCode(currentColCharCode++) })
            kyuryoCol.other = String.fromCharCode(currentColCharCode++)
            const kyuryoSumColName = String.fromCharCode(currentColCharCode++)

            // ★修正: 燃費列の分、カーソルを1つ進める
            currentColCharCode++

            // 金額セクション
            const kingakuCol = {}
            enabledKubunList.forEach(kubun => { kingakuCol[kubun] = String.fromCharCode(currentColCharCode++) })
            kingakuCol.other = String.fromCharCode(currentColCharCode++)

            // ★修正: 金額合計列の分、カーソルを1つ進める
            currentColCharCode++

            // 非表示の単価列（固定の5列）
            const tankaCol = {}
            masterFuelOrder.forEach(kubun => { tankaCol[kubun] = String.fromCharCode(currentColCharCode++) })

            // --- STEP 2: 各プロパティに設定する数式を生成 --- (これ以降のロジックは変更なし)

            // 1. 総給油量
            const kyuryoSumParts = []
            enabledKubunList.forEach(kubun => kyuryoSumParts.push(`${kyuryoCol[kubun]}${y}`))
            kyuryoSumParts.push(`${kyuryoCol.other}${y}`)
            elem.kyuyuryoSumFormula = `=${kyuryoSumParts.join('+')}`

            // 2. 燃費
            const sokoKyoriCell = `C${y}`
            const kyuryoSumCell = `${kyuryoSumColName}${y}`
            elem.nenpiFormula = `=IF(${kyuryoSumCell}=0, 0, ${sokoKyoriCell}/${kyuryoSumCell})`

            // 3. 各燃料の金額 (単価 * 給油量)
            enabledKubunList.forEach(kubun => {
              const propName = kubunToFormulaPropMap.get(kubun)
              const kyuryoCell = `${kyuryoCol[kubun]}${y}`
              const tankaCell = `${tankaCol[kubun]}${y}`

              if (propName) {
                elem[propName] = `=${tankaCell}*${kyuryoCell}`
              }
            })

            // 4. 金額合計
            const kingakuGokeiParts = []
            enabledKubunList.forEach(kubun => kingakuGokeiParts.push(`${kingakuCol[kubun]}${y}`))
            kingakuGokeiParts.push(`${kingakuCol.other}${y}`)
            elem.kyuyukingakuSumFormula = `=${kingakuGokeiParts.join('+')}`

            return elem
          })

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          data.payload = data.payload.resultList
          self.saveToChache(cache)
            .then(() => {
              return {
              }
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return this.initBindVariables()
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    searchValidate: function () {
      return true
    },
    onMultiSaveButtonClick: function () {
      const self = this

      // --- STEP 1: jSpreadsheetインスタンスの取得と確認 ---
      // ref="ddSpreadSheet" を経由してコンポーネントインスタンスを取得
      const ddSpreadSheetComponent = self.$refs.ddSpreadSheet
      // ラッパーコンポーネントからネイティブのjSpreadsheetインスタンスを取得
      const spreadsheetInstance = ddSpreadSheetComponent.jspreadsheetObj

      // --- STEP 3: jSpreadsheetから計算済みのデータを一括取得 ---
      // .getData(false, true) は、非表示列を含め、計算済みの値(calculated values)を取得します
      const sheetData = spreadsheetInstance.getData(false, true)

      // --- STEP 4: `editFlg`がtrueの行を対象に、API送信用データを構築 ---
      const saveTargetRow = []
      self.rows.forEach((row, rowIndex) => {
        if (row.editFlg === true) {
          const calculatedRow = sheetData[rowIndex]
          const apiRow = { ...row }

          apiRow.kingakuRegular = !['', null, undefined].includes(calculatedRow.kingakuRegularFormula) ? filter.parseNumeric(calculatedRow.kingakuRegularFormula, '円') : 0
          apiRow.kingakuHighOctane = !['', null, undefined].includes(calculatedRow.kingakuHighOctaneFormula) ? filter.parseNumeric(calculatedRow.kingakuHighOctaneFormula, '円') : 0
          apiRow.kingakuDiesel = !['', null, undefined].includes(calculatedRow.kingakuDieselFormula) ? filter.parseNumeric(calculatedRow.kingakuDieselFormula, '円') : 0
          apiRow.kingakuLpGas = !['', null, undefined].includes(calculatedRow.kingakuLpGasFormula) ? filter.parseNumeric(calculatedRow.kingakuLpGasFormula, '円') : 0
          apiRow.kingakuNaturalGas = !['', null, undefined].includes(calculatedRow.kingakuNaturalGasFormula) ? filter.parseNumeric(calculatedRow.kingakuNaturalGasFormula, '円') : 0

          saveTargetRow.push(apiRow)
        }
      })

      if (saveTargetRow.length < 1) { return }

      self.targetKyuyuJissekiList = saveTargetRow
      self.$nextTick(function () {
        self.saveAction()
      })
    },
    saveAction: function () {
      this.Effects.loadStart()
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.post('/api/v1/VwCD2fued0060/BulkRegister', self.targetKyuyuJissekiList)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.Effects.loadComplete()
            this.$nextTick(function () {
              self.targetKyuyuJissekiList = []
              self.onSearchButtonClick()
            })
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    // 登録前チェック
    registerValidate: function () {
      return true
    },

    /**
     * スプレッドシート制御
     * @returns
     */
    setHeader: function (p) {
      console.log('setHeader')
      const self = this
      return new Promise(resolve => {
        // 基本ヘッダー
        self.headers = [
          { title: '車両名', name: 'jidoshaHyojiNm', validateType: 'Free', validateLength: 100, required: true, readOnly: true, width: '150px' },
          { title: '給油年月', name: 'keijoNengetsu', type: 'text', validateType: 'Free', validateLength: 50, customInput: null, required: true, readOnly: false, align: 'center', width: '80px' },
          { title: '走行距離(km)', name: 'sokoKyori', type: null, customInput: 'numeric', customInputIntDigit: 8, customInputDecimalDigit: 1, readOnly: false, align: 'right', width: '120px', mask: '#,##0 Km' }
        ]

        // APIのフィールド名をcodeに紐付けるための定義
        const fuelApiNameMap = {
          '01': { kyuyuryoName: 'suryoRegular', kingakuName: 'kingakuRegularFormula' },
          '02': { kyuyuryoName: 'suryoHighOctane', kingakuName: 'kingakuHighOctaneFormula' },
          '03': { kyuyuryoName: 'suryoDiesel', kingakuName: 'kingakuDieselFormula' },
          '04': { kyuyuryoName: 'suryoLpGas', kingakuName: 'kingakuLpGasFormula' },
          '05': { kyuyuryoName: 'suryoNaturalGas', kingakuName: 'kingakuNaturalGasFormula' }
        }

        console.log('filteredNenryoKubunList', self.filteredNenryoKubunList)
        // filteredNenryoKubunList を基に、動的な燃料種別の定義を生成する
        const dynamicFuelTypes = self.filteredNenryoKubunList.map(nenryo => {
          const apiNames = fuelApiNameMap[nenryo.code]
          if (!apiNames) return null

          return {
            code: nenryo.code,
            name: nenryo.codeNm,
            kyuyuryoName: apiNames.kyuyuryoName,
            kingakuName: apiNames.kingakuName
          }
        }).filter(item => item !== null)

        const enabledFuelTypes = !['', null, undefined].includes(p) ? dynamicFuelTypes.filter(fuel => p.includes(fuel.code)) : []

        // ---- 給油量ヘッダー ----
        // pの値に基づく動的ヘッダー
        enabledFuelTypes.forEach(fuel => {
          self.headers.push({ title: `${fuel.name}給油量(L)`, name: fuel.kyuyuryoName, type: null, customInput: 'numeric', customInputIntDigit: 4, customInputDecimalDigit: 2, readOnly: false, align: 'right', width: '100px', mask: '#,##0.00 ℓ' })
        })
        // 「その他」の固定ヘッダー
        self.headers.push({ title: 'その他給油量(L)', name: 'suryoOther', type: null, customInput: 'numeric', customInputIntDigit: 4, customInputDecimalDigit: 2, readOnly: false, align: 'right', width: '100px', mask: '#,##0.00 ℓ' })

        // ---- 固定ヘッダー（総給油量・燃費）----
        self.headers.push(
          { title: '総給油量', name: 'kyuyuryoSumFormula', type: null, customInput: 'numeric', customInputIntDigit: 4, customInputDecimalDigit: 1, readOnly: true, align: 'right', width: '100px', mask: '#,##0.00 ℓ' },
          { title: '燃費', name: 'nenpiFormula', type: null, customInput: 'numeric', customInputIntDigit: 4, customInputDecimalDigit: 2, readOnly: true, align: 'right', width: '100px', mask: '#,##0.00 Km/ℓ' }
        )

        // ---- 給油額ヘッダー ----
        // pの値に基づく動的ヘッダー
        enabledFuelTypes.forEach(fuel => {
          self.headers.push({ title: `${fuel.name}給油額(円)`, name: fuel.kingakuName, type: null, customInput: 'numeric', customInputIntDigit: 8, customInputDecimalDigit: 0, readOnly: true, align: 'right', width: '100px', mask: '#,##0 円' })
        })
        // 「その他」の固定ヘッダー
        self.headers.push({ title: 'その他給油額(円)', name: 'kingakuOther', type: null, customInput: 'numeric', customInputIntDigit: 8, customInputDecimalDigit: 0, readOnly: false, align: 'right', width: '100px', mask: '#,##0 円' })
        // ---- 固定ヘッダー（合計金額） ----
        self.headers.push({ title: '給油額合計', name: 'kyuyukingakuSumFormula', type: null, customInput: 'numeric', customInputIntDigit: 6, customInputDecimalDigit: 0, readOnly: true, align: 'right', width: '100px', mask: '#,##0 円' })
        // --- 単価を保持するための非表示列を定義 ---
        self.headers.push({ title: '単価(レギュラー)', name: 'tankaMasterRegular', type: 'hidden' })
        self.headers.push({ title: '単価(ハイオク)', name: 'tankaMasterHighOctane', type: 'hidden' })
        self.headers.push({ title: '単価(軽油)', name: 'tankaMasterDiesel', type: 'hidden' })
        self.headers.push({ title: '単価(LPガス)', name: 'tankaMasterLpGas', type: 'hidden' })
        self.headers.push({ title: '単価(天然ガス)', name: 'tankaMasterNaturalGas', type: 'hidden' })
        resolve()
      })
    },

    settingKeijoNengetsu: function (p) {
      this.conditions.keijoNengetsu = p
    },

    onXlsOutputButtonClick: function (e) {
      this.isXlsDownloader = true

      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2fued0060/ExcelOutput', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('xlsdownload')
          this.isXlsDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '車両別燃費管理_' + ts + '.xlsx'
          elem.click()
        })
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const self = this
      var today = new Date()
      self.conditions = {
        keijoNengetsu: ('000' + today.getFullYear()).slice(-4) + '/' + ('0' + (today.getMonth() + 1)).slice(-2),
        eigyoshoCd: self.usersEigyoshoCd,
        jidoshaHyojiNm: ''
      }
      self.searchedKeijoNengetsu = null
      self.searchedEigyoshoCd = null
      self.searchedJidoshaHyojiNm = null
      self.targetKyuyuJissekiList = []
      self.searchText = ''
      self.rows = []
      self.page = 1
      self.selected = []
    },

    onDummyFunction: function () {
      return null
    }
  }
}
